var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGitlabMark = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "33px",
    viewBox: "0 0 35 33",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "gitlab-9dd03e952192df4a1bba7d1abe03fb0de7af06dbff9d014beabd91d39e9e0861")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HS-home-page-refresh-2020_test",
    transform: "translate(-182.000000, -6324.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(166.000000, 6307.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gitlab-9dd03e952192df4a1bba7d1abe03fb0de7af06dbff9d014beabd91d39e9e0861",
    transform: "translate(16.271429, 17.228571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3930143,18.3101429 C34.5691074,18.8515067 34.3771625,19.4447205 33.9173143,19.7803143 L17.2285714,31.9044429 L0.541742857,19.7803143 C0.0815047664,19.4463108 -0.110997439,18.8537287 0.0650857143,18.3130143 L1.99277143,12.3787286 L5.81368571,0.618314286 C6.0099,0.0134 6.86654286,0.0134 7.06371429,0.618314286 L10.8827143,12.3787286 L23.5744286,12.3787286 L27.3953429,0.617357143 C27.5915571,0.0124428571 28.4482,0.0124428571 28.6453714,0.617357143 L32.4643714,12.3777714 L34.3939714,18.3111",
    id: "Path",
    fill: "#F36E2C"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E2452A",
    points: "17.2285714 31.9044429 10.8846286 12.3777714 23.5744286 12.3777714 17.2285714 31.9034857"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F36E2C",
    points: "17.2285714 31.9034857 1.99277143 12.3777714 10.8846286 12.3777714 17.2295286 31.9034857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.99277143,12.3777714 L17.2304857,31.9034857 L0.541742857,19.7793571 C0.0811519751,19.4456104 -0.111752767,18.8529792 0.0641285714,18.3120571 L1.99277143,12.3777714 L1.99277143,12.3777714 Z",
    id: "Path",
    fill: "#FAA328"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.99372857,12.3768143 L5.81655714,0.6164 C6.01181429,0.0114857143 6.8675,0.0114857143 7.06562857,0.6164 L10.8865429,12.3768143 L1.99372857,12.3768143 Z",
    id: "Path",
    fill: "#E2452A"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F36E2C",
    points: "17.2285714 31.9034857 32.4643714 12.3777714 23.5725143 12.3777714 17.2295286 31.9034857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4653286,12.3777714 L17.2285714,31.9034857 L33.9154,19.7793571 C34.3738714,19.4443571 34.5691286,18.8509286 34.3920571,18.3120571 L32.4643714,12.3777714 L32.4653286,12.3777714 Z",
    id: "Path",
    fill: "#FAA328"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4662857,12.3768143 L28.6453714,0.6164 C28.4472429,0.0114857143 27.5906,0.0114857143 27.3943857,0.6164 L23.5734714,12.3768143 L32.4662857,12.3768143 Z",
    id: "Path",
    fill: "#E2452A"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGitlabMark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/gitlab-mark.98b306c7.svg";
export { ForwardRef as ReactComponent };